import { OAuthProviderSchema } from "./oauth-providers";
import { z } from "zod";
export const IntegrationTokenSchemaOld = z.object({
    id: z.string(),
    provider: OAuthProviderSchema,
    scope: z.string(),
    userId: z.string(),
    accessToken: z.string(),
    refreshToken: z.string(),
    expiresAt: z.coerce.date(),
    externalUserId: z.string().nullish(),
});
